import { Paper, styled } from '@mui/material';
export var PagePaper = styled(Paper)(function (_a) {
    var theme = _a.theme;
    return ({
        padding: theme.spacing(3),
        marginBottom: theme.spacing(4),
        elevation: 3,
        borderRadius: '8px',
    });
});
